import {
    AfterViewInit,
    Component,
    Inject,
    OnInit,
    ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Actividad } from '../../../../interfaces/interface-bakend/ofertas-laborales/actividad.interface';
import { PaisDisponible } from '../../../../interfaces/interface-bakend/shared/paises/pais-disponible/pais-disponible.interface';
import { Pais } from '../../../../interfaces/interface-bakend/shared/paises/pais.interfaces';
import { Catalogo } from '../../../../interfaces/interface-bakend/shared/catalogo/catalogo.interface';
import {
    APP_CONFIG_SHARED,
    IAppShared,
} from '../../../../app.config/app.config-shared';
import { UsuarioService } from '../../../../services/shared/usuario.service';
import { CatalogoService } from '../../../../services/shared/catalogo.service';
import { GuiToolsService } from '../../../../services/shared/gui-tools.service';
import { Translators } from '../../../../services/shared/translators.service';
import { Subscription } from 'rxjs';
import { PaisesService } from '../../../../services/shared/paises.service';
import { GuiMsjService } from '../../../../services/shared/gui-msj.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ModalConfirmarComponent } from '../../../ofertas-laborales/pages/solicitud-postular/modal-confirmar/modal-confirmar.component';
import { PreviousRouteService } from '@services/shared/previous-route.service';
import { UserEntreUserService } from '@services/shared/user-entre-user.service';
import { User } from '../../../../interfaces/interface-bakend/seguridad/users/user.interface';
import { PersonasService } from 'src/app/services/shared/personas.service';
import { SignoSede } from '@interfaces/interface-bakend/entidades/signo-sede.interface';
import { SignoSedeService } from '@services/entidades/signo-sedes.service';
import { SignoPlan } from '@interfaces/interface-bakend/entidades/signo-plan.interface';
import { SignoPlanService } from '@services/entidades/signo-planes.service';
import { SignoEmpresa } from '@interfaces/interface-bakend/entidades/signo-empresa.interface';
import { SignoEmpresaService } from '@services/entidades/signo-empresas.service';
import { SignoGestion } from '@interfaces/interface-bakend/entidades/signo-gestion-interface';
import { PATOLOGIAS_CONFIG } from '@interfaces/interface-bakend/patologias/patologias';
import { SolicitudesService } from '@services/ofertas-laborales/solicitudes.service';
import { Solicitud } from '@interfaces/interface-bakend/ofertas-laborales/solicitudes.interface';
import { OfertasSolicitudComponent } from '@components/ofertas-laborales/pages/ofertas-administracion/ofertas-solicitud/ofertas-solicitud.component';
import { GecrosAfiliadosService } from 'src/app/services/entidades/gecros-afiliados.service';
import { GecrosSyncService } from '@services/entidades/gecros-sync.service';
import { buscarPlanPorGecros } from '@shared/utils/plan.util';
import { ChangeDetectorRef } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Parentesco } from 'src/app/auth/inscripcion-os/interfaz-inscripcion-os/inscripcion-os-interface';
import { FamiliarModalAltaComponent } from './familiar-modal-alta/familiar-modal-alta.component';

@Component({
    selector: 'app-persona-modificacion',
    templateUrl: './persona-modificacion.component.html',
    styleUrls: ['./persona-modificacion.component.scss'],
})
export class PersonaModificacionComponent implements OnInit, AfterViewInit {
    usuario: User;
    formAfiliado: FormGroup;
    actividad: Actividad;
    pais: PaisDisponible;
    nombrePais: string;
    nombreActividad: string;

    paises: Pais[] = [];
    paisCodeAreas: Pais[] = [];
    estadosCiviles: Catalogo[] = [];
    tiposIdentificaciones: Catalogo[] = [];
    paisDondeAplicaFormas: Catalogo[] = [];
    sedes: SignoSede[] = [];
    planes: SignoPlan[] = [];
    empresas: SignoEmpresa[] = [];
    idiomas: Catalogo[] = [];

    selectedEstadoCivil: Catalogo;
    selectedTipoIdentificacion: Catalogo;
    selectedCondiMigra: Catalogo;
    selectedPais: Pais;
    selectedSede: SignoSede;
    selectedPlan: SignoPlan;
    selectedEmpresa: SignoEmpresa;

    flagLoaded: boolean = false;
    flagProcesando: boolean = false;
    flagFormAfiliadoValido: boolean = false;

    private readonly FECHA_CORTE_FILTRO = new Date('2026-08-04T00:00:00.000Z');
    flagExisteUsuarioConIdentificacion: boolean = false;
    flagExisteIdentificacion: boolean = false;
    flagPreCarga: boolean = false;
    flagoConfirmData: boolean = false;
    flagGrupoFamiliar: boolean = false;

    idioma: Subscription;

    /*Gestion*/
    isPMI: boolean = false;
    isDisability: boolean = false;
    isChronicities: boolean = false;
    estados: string[] = ['ACTIVA', 'SUSPENDIDA', 'BAJA', 'DESCONOCIDO'];

    /* Data Table Grupo Familiar*/
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    displayedColumns: string[] = [
        'nombre',
        'identificacion',
        'domicilio',
        'email',
        'sede',
        'plan',
        'empresa',
        'acciones',
    ];
    dataSource: MatTableDataSource<User>;

    routes: { url: string; label: string }[] = [];

    mostrarCard = false;

    patologiasDisponibles: string[] = PATOLOGIAS_CONFIG;

    solicitudesDataSource = new MatTableDataSource<any>([]);
    displayedColumnsSolicitudes: string[] = [
        'nro solicitud',
        'fecha',
        'estado',
        'acciones',
    ];
    loadingSolicitud = false;
    loading = false;

    @ViewChild('soliPaginator') soliPaginator: MatPaginator;

    tabActiva: string = 'informacion';

    isLoading: boolean = false;

    gecrosData: any = null;

    constructor(
        @Inject(APP_CONFIG_SHARED) private iAppShared: IAppShared,
        private paisesService: PaisesService,
        private catalogoService: CatalogoService,
        private guiMsjService: GuiMsjService,
        private guiToolsService: GuiToolsService,
        private router: Router,
        private previousRouteService: PreviousRouteService,
        private usuarioService: UsuarioService,
        public dialog: MatDialog,
        private translatorService: Translators,
        private personasService: PersonasService,
        private signoSedeService: SignoSedeService,
        private signoPlanService: SignoPlanService,
        private signoEmpresaService: SignoEmpresaService,
        private userEntreUserService: UserEntreUserService,
        private solicitudesService: SolicitudesService,
        private gecrosAfiliadosService: GecrosAfiliadosService,
        private gecrosSyncService: GecrosSyncService,
        private cdr: ChangeDetectorRef,
        private authService: AuthService,
    ) {
        this.idioma = this.translatorService
            .getIdiomaSeleccionado()
            .subscribe((resp) => {
                this.idioma = resp;
            });

        this.createFormAfiliado();
    }

    async ngOnInit(): Promise<void> {
        this.previousRouteService
            .getRoutes()
            .subscribe((routes) => {
                this.routes = routes;
            })
            .unsubscribe();
        await this.getData();
        await this.loadUserAndForm();
    }

    ngAfterViewInit(): void {
        this.loadGrupoFamiliar();
        this.loadSolicitudes();
    }

    getEstadoAfiliado(estado: string): string {
        switch (estado) {
            case 'Con Cobertura':
                return 'ACTIVA';
            case 'Sin Cobertura por Baja':
                return 'BAJA';
            case 'Momentáneamente sin cobertura':
                return 'SUSPENDIDA';
            default:
                return 'DESCONOCIDO';
        }
    }

    async getData() {
        await this.getPaises();
        await this.getEstadosCiviles();
        await this.getTipoIdentificaciones();
        await this.getPaisDondeAplicaFormas();
        await this.getSedes();
        await this.getPlanes();
        await this.getEmpresas();

        this.flagLoaded = true;
    }

    /* Validaciones */
    get nombre() {
        return (
            this.formAfiliado.get('nombre').invalid &&
            this.formAfiliado.get('nombre').touched
        );
    }

    get apellido() {
        return (
            this.formAfiliado.get('apellido').invalid &&
            this.formAfiliado.get('apellido').touched
        );
    }

    get tipoIdentificacion() {
        return (
            this.formAfiliado.get('tipoIdentificacion').invalid &&
            this.formAfiliado.get('tipoIdentificacion').touched
        );
    }

    get identificacion() {
        return (
            this.formAfiliado.get('identificacion').invalid &&
            this.formAfiliado.get('identificacion').touched
        );
    }

    get birth() {
        return (
            this.formAfiliado.get('birth').invalid &&
            this.formAfiliado.get('birth').touched
        );
    }

    get paisNacimiento() {
        return (
            this.formAfiliado.get('paisNacimiento').invalid &&
            this.formAfiliado.get('paisNacimiento').touched
        );
    }

    get paisCodeArea() {
        return (
            this.formAfiliado.get('paisCodeArea').invalid &&
            this.formAfiliado.get('paisCodeArea').touched
        );
    }

    get telefono() {
        return (
            this.formAfiliado.get('telefono').invalid &&
            this.formAfiliado.get('telefono').touched
        );
    }

    get estado() {
        return (
            this.formAfiliado.get('estado').invalid &&
            this.formAfiliado.get('estado').touched
        );
    }

    get fechaVigenciaNoValida() {
        return (
            this.formAfiliado.get('fechaVigencia').invalid &&
            this.formAfiliado.get('fechaVigencia').touched
        );
    }

    get plan() {
        return this.formAfiliado.get('signoPlan').invalid;
    }

    get sede() {
        return this.formAfiliado.get('signoSedes').invalid;
    }

    get empresa() {
        return this.formAfiliado.get('signoEmpresas').invalid;
    }

    get fechaNoValida() {
        return this.formAfiliado.get('fechaBaja').invalid;
    }

    get fechaNoValidaCronicidades() {
        return this.formAfiliado.get('fechaVtoOtrasCronicidades').invalid;
    }
    /* Fin Validaciones */

    /* Métodos form */
    async onSubmit() {
        const usuarioUpdated: User = await this.setDataForma();

        this.flagoConfirmData = await this.openDialogConfirmData(
            usuarioUpdated
        );

        if (this.flagoConfirmData) {
            this.flagFormAfiliadoValido = false;
            this.flagProcesando = true;
            this.usuarioUpdate(usuarioUpdated);
        } else {
            return;
        }
    }

    createFormAfiliado() {
        this.formAfiliado = new FormGroup({
            nombre: new FormControl('', [Validators.required]),
            apellido: new FormControl('', [Validators.required]),
            tipoIdentificacion: new FormControl('', [Validators.required]),
            identificacion: new FormControl('', [Validators.required]),
            paisNacimiento: new FormControl(''),
            estadoCivil: new FormControl(''),
            paisCodeArea: new FormControl(''),
            telefono: new FormControl(''),
            birth: new FormControl('', [Validators.required]),
            signoSedes: new FormControl('', [Validators.required]),
            signoPlan: new FormControl('', Validators.required),
            signoEmpresas: new FormControl(''),
            estado: new FormControl(''),
            fechaVigencia: new FormControl(''),
            fechaCobertura: new FormControl(''),
            fechaBaja: new FormControl(''),
            pmi: new FormControl(false),
            fechaVtoPMI: new FormControl(''),
            discapacidad: new FormControl(false),
            fechaVtoDiscapacidad: new FormControl(''),
            otrasCronicidades: new FormControl(false),
            fechaVtoOtrasCronicidades: new FormControl(''),
            patologias: new FormControl([]),
            reinscripcionOs: new FormControl(false),
        });
    }

    async loadSelectedData(afiliado: User) {
        try {
            const sedeItem = afiliado?.signoSedes?.[0];
            const sedeId = typeof sedeItem === 'string' ? sedeItem : (sedeItem as any)?._id;
            if (sedeId) {
                this.selectedSede = await this.signoSedeService.getSedeById(sedeId);
            } else {
                this.selectedSede = null;
            }

            const empresaItem = afiliado?.signoEmpresas?.[0];
            const empresaId = typeof empresaItem === 'string' ? empresaItem : (empresaItem as any)?._id;
            if (empresaId) {
                this.selectedEmpresa = await this.signoEmpresaService.getEmpresaById(empresaId);
            } else {
                this.selectedEmpresa = null;
            }

            const planId = afiliado?.signoPlan;
            if (planId) {
                const plan = await this.signoPlanService.getPlanById(planId);
                this.selectedPlan = plan as SignoPlan;
            } else {
                this.selectedPlan = null;
            }
        } catch (error) {
            console.error('Error al cargar los datos:', error);
            this.selectedSede = null;
            this.selectedEmpresa = null;
            this.selectedPlan = null;
        }
    }

    async cargarFormAfiliado(usuario: User) {
        try {
            let fechaNacimientoStr: string | null = null;
            if (usuario.signoGecrosAfiliado?.fechaNacimiento) {
                const partes = usuario.signoGecrosAfiliado.fechaNacimiento.split('/');
                if (partes.length === 3) {
                    const dia = partes[0].padStart(2, '0');
                    const mes = partes[1].padStart(2, '0');
                    const anio = partes[2];
                    fechaNacimientoStr = `${anio}-${mes}-${dia}`;
                }
            }
            if (!fechaNacimientoStr && usuario.birth) {
                fechaNacimientoStr = this.guiToolsService.datePipeTransform(usuario.birth, 'yyyy-MM-dd');
            }
            if (!fechaNacimientoStr) {
                fechaNacimientoStr = this.guiToolsService.datePipeTransform(new Date(), 'yyyy-MM-dd');
            }

            

            const formValues: any = {
                nombre: usuario?.nombrePersona || '',
                apellido: usuario?.apellidoPersona || '',
                tipoIdentificacion: usuario?.tipoIdentificacion?.concepto || '',
                identificacion: usuario?.identificacion || '',
                birth: fechaNacimientoStr,
                paisNacimiento: usuario?.paisNacimiento?.name_es || '',
                estadoCivil: usuario?.estadoCivil?.concepto || '',
                paisCodeArea: usuario?.paisCodeArea || '',
                telefono: usuario?.telefono || '',
                signoSedes: this.selectedSede?._id || '',
                signoPlan: this.selectedPlan?._id || '',
                signoEmpresas: this.selectedEmpresa?._id || '',
                estado: this.getEstadoAfiliado(usuario?.signoGecrosAfiliado?.estado),
                patologias: usuario?.patologias || [],
                fechaVigencia: usuario?.signoGestion?.fechaVigencia 
                    ? this.guiToolsService.datePipeTransform(usuario.signoGestion.fechaVigencia, 'yyyy-MM-dd')
                    : this.guiToolsService.datePipeTransform(new Date(), 'yyyy-MM-dd'),
                fechaCobertura: usuario?.signoGestion?.fechaCobertura 
                    ? this.guiToolsService.datePipeTransform(usuario.signoGestion.fechaCobertura, 'yyyy-MM-dd')
                    : this.guiToolsService.datePipeTransform(new Date(), 'yyyy-MM-dd'),
                fechaBaja: usuario?.signoGestion?.fechaBaja 
                    ? this.guiToolsService.datePipeTransform(usuario.signoGestion.fechaBaja, 'yyyy-MM-dd')
                    : this.guiToolsService.datePipeTransform(new Date(), 'yyyy-MM-dd'),
                pmi: usuario?.signoGestion?.pmi || false,
                fechaVtoPMI: usuario?.signoGestion?.fechaVtoPmi 
                    ? this.guiToolsService.datePipeTransform(usuario.signoGestion.fechaVtoPmi, 'yyyy-MM-dd')
                    : this.guiToolsService.datePipeTransform(new Date(), 'yyyy-MM-dd'),
                discapacidad: usuario?.signoGestion?.discapacidad || false,
                fechaVtoDiscapacidad: usuario?.signoGestion?.fechaVtoDiscapacidad 
                    ? this.guiToolsService.datePipeTransform(usuario.signoGestion.fechaVtoDiscapacidad, 'yyyy-MM-dd')
                    : this.guiToolsService.datePipeTransform(new Date(), 'yyyy-MM-dd'),
                otrasCronicidades: usuario?.signoGestion?.otrasCronicidades || false,
                fechaVtoOtrasCronicidades: usuario?.signoGestion?.fechaVtoOtrasCronicidades 
                    ? this.guiToolsService.datePipeTransform(usuario.signoGestion.fechaVtoOtrasCronicidades, 'yyyy-MM-dd')
                    : this.guiToolsService.datePipeTransform(new Date(), 'yyyy-MM-dd'),
                reinscripcionOs: usuario?.reinscripcionOs === true,
            };

            this.formAfiliado.setValue(formValues);

            this.selectedTipoIdentificacion = usuario?.tipoIdentificacion;
            this.selectedEstadoCivil = usuario?.estadoCivil;
            this.selectedPais = usuario?.paisNacimiento;
            
            this.isPMI = usuario?.signoGestion?.pmi || false;
            this.isDisability = usuario?.signoGestion?.discapacidad || false;
            this.isChronicities = usuario?.signoGestion?.otrasCronicidades || false;
        } catch (error) {
            console.error('Error al cargar los datos asociado al afiliado:', error);
        }
    }

    async loadUserAndForm() {
        try {
            const afiliadoSeleccionado = this.personasService.getPersonaSeleccionada();

            if (!afiliadoSeleccionado) {
                throw new Error('No hay afiliado seleccionado.');
            }

            this.usuario = afiliadoSeleccionado;
            
            await this.loadSelectedData(this.usuario);
            await this.cargarFormAfiliado(this.usuario);

            await this.obtenerDatosGecros();
        } catch (error) {
            console.error('Error al cargar los datos asociado al afiliado:', error);
            await this.router.navigateByUrl('/afiliados-listado');
        }
    }

    async setDataForma(): Promise<User> {
        const dataFormaGestion: SignoGestion = {
            estado: this.formAfiliado.value.estado,
            fechaVigencia: this.formAfiliado.value.fechaVigencia,
            fechaBaja: this.formAfiliado.value.fechaBaja,
            fechaCobertura: this.formAfiliado.value.fechaCobertura,
            pmi: this.formAfiliado.value.pmi,
            fechaVtoPmi: this.formAfiliado.value.fechaVtoPMI,
            discapacidad: this.formAfiliado.value.discapacidad,
            fechaVtoDiscapacidad: this.formAfiliado.value.fechaVtoDiscapacidad,
            otrasCronicidades: this.formAfiliado.value.otrasCronicidades,
            fechaVtoOtrasCronicidades: this.formAfiliado.value.fechaVtoOtrasCronicidades,
        };

        const dataForma: any = {
            nombrePersona: this.formAfiliado.value.nombre.toUpperCase(),
            apellidoPersona: this.formAfiliado.value.apellido.toUpperCase(),
            tipoIdentificacion: this.selectedTipoIdentificacion,
            identificacion: this.formAfiliado.value.identificacion,
            birth: new Date(this.formAfiliado.value.birth).toISOString(),
            paisNacimiento: this.selectedPais,
            estadoCivil: this.selectedEstadoCivil,
            paisCodeArea: this.formAfiliado.value.paisCodeArea,
            telefono: this.formAfiliado.value.telefono,
            fromApp: false,
            fromWeb: true,
            esPersona: true,
            signoSedes: [this.formAfiliado.value.signoSedes],
            signoPlan: this.formAfiliado.value.signoPlan,
            signoGestion: dataFormaGestion || null,
            patologias: this.formAfiliado.value.patologias,
            reinscripcionOs: this.formAfiliado.value.reinscripcionOs === true,
        };

        if (this.formAfiliado.value.signoEmpresas) {
            dataForma.signoEmpresas = [this.formAfiliado.value.signoEmpresas];
        }

        return dataForma;
    }

    createListenersStateForm() {
        return this.formAfiliado.statusChanges.subscribe(async (status) => {
            this.validarIdentificacionModificada(status);
        });
    }

    reloadCurrentRoute() {
        this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
                this.router.navigate(['afiliados-listado']);
                return;
            });
    }

    usuarioUpdate(usuarioUpdated: User) {
        this.usuarioService
            .updateUser(
                this.personasService.getPersonaSeleccionada()._id,
                usuarioUpdated
            )
            .then((usuario: User) => {
                if (usuario) {
                    this.guiMsjService.msjFormSubmit('afiliadoModificadoOK');
                    this.router.navigateByUrl('/afiliados-listado');
                    this.reloadCurrentRoute();
                } else {
                    this.guiMsjService.msjFormSubmit('afiliadoModificadoError');
                    this.router.navigateByUrl('/afiliado-modificacion');
                }
            });
    }

    async validarIdentificacionModificada(status: string) {
        if (this.formAfiliado.value.identificacion) {
            if (
                this.personasService.getPersonaSeleccionada().identificacion !==
                this.formAfiliado.value.identificacion
            ) {
                this.flagExisteIdentificacion =
                    await this.usuarioService.getExistsTipoAndIdentificacion(
                        this.selectedTipoIdentificacion._id,
                        this.formAfiliado.value.identificacion
                    );
            } else {
                this.flagExisteIdentificacion = false;
            }

            if (status === 'VALID' && !this.flagExisteIdentificacion) {
                this.flagFormAfiliadoValido = true;
            } else {
                this.flagFormAfiliadoValido = false;
            }
        } else {
            return;
        }
    }

    /* Selectores */
    onChangePais(event: string): void {
        this.selectedPais = this.paises.filter((x) => x.name_es === event)[0];
    }

    onChangeTipoIdentificacion(event: string): void {
        this.selectedTipoIdentificacion = this.tiposIdentificaciones.filter(
            (x) => x.concepto === event
        )[0];
    }

    onChangeCondiMigra(event: string): void {
        this.selectedCondiMigra = this.paisDondeAplicaFormas.filter(
            (x) => x.concepto === event
        )[0];
    }

    onChangeEstadoCivil(event: string): void {
        this.selectedEstadoCivil = this.estadosCiviles.filter(
            (x) => x.concepto === event
        )[0];
    }

    updateValuesPMI(isChecked: boolean) {
        this.isPMI = isChecked;
        this.formAfiliado.controls['pmi'].setValue(isChecked);
    }

    updateValuesDisability(isChecked: boolean) {
        this.isDisability = isChecked;
        this.formAfiliado.controls['discapacidad'].setValue(isChecked);
    }

    updateValuesChronicities(isChecked: boolean) {
        this.isChronicities = isChecked;
        this.formAfiliado.controls['otrasCronicidades'].setValue(isChecked);
    }

    async getPaises() {
        await this.paisesService.getPaises().then((resp: Pais[]) => {
            this.paises = resp;
        });
    }

    async getSedes() {
        try {
            this.sedes = await this.signoSedeService.getSedes();
        } catch (error) {
            console.error('Error al obtener sedes:', error);
        }
    }

    async getPlanes() {
        try {
            this.planes = await this.signoPlanService.getPlanes();
        } catch (error) {
            console.error('Error al obtener planes:', error);
        }
    }

    async getEmpresas() {
        try {
            this.empresas = await this.signoEmpresaService.getEmpresas();
        } catch (error) {
            console.error('Error al obtener empresas:', error);
        }
    }

    async getEstadosCiviles() {
        await this.catalogoService
            .findDescendantsByKeyByLenguage(
                this.iAppShared.estadoCivil,
                this.translatorService.getIdioma()
            )
            .then((resp: Catalogo[]) => {
                return (this.estadosCiviles = resp);
            });
    }

    async getTipoIdentificaciones() {
        await this.catalogoService
            .findDescendantsByKeyByLenguage(
                this.iAppShared.tiposIdentificaciones,
                this.translatorService.getIdioma()
            )
            .then((resp: Catalogo[]) => {
                return (this.tiposIdentificaciones = resp);
            });
    }

    async getPaisDondeAplicaFormas() {
        await this.catalogoService
            .findDescendantsByKeyByLenguage(
                this.iAppShared.paisDondeAplica,
                this.translatorService.getIdioma()
            )
            .then((resp: Catalogo[]) => {
                return (this.paisDondeAplicaFormas = resp);
            });
    }
    /* Fin Selectores */

    formatDomicilio(calle: string, numero: string): string {
        return calle?.replace(/\s+/g, '') + ' ' + numero;
    }

    async getDataAfiliado(
        sedeId: string,
        empresaId?: string,
        planId?: string
    ): Promise<{ sede: string; plan: string; empresa: string }> {
        try {
            const sede = sedeId
                ? (await this.signoSedeService.getSedeById(sedeId))?.nombre
                : 'Sin sede asociada';
            const plan = planId
                ? (await this.signoPlanService.getPlanById(planId))?.denominacion
                : 'Sin plan asociado';
            const empresa = empresaId
                ? (await this.signoEmpresaService.getEmpresaById(empresaId))?.nombre
                : 'Sin empresa asociada';
            return { sede, plan, empresa };
        } catch (error) {
            console.error(error, 'Error al obtener los datos del familiar');
            return { sede: undefined, plan: undefined, empresa: undefined };
        }
    }

    async loadDataTable() {
        try {
            const afiliadoSeleccionado = this.personasService.getPersonaSeleccionada();

            if (!afiliadoSeleccionado) {
                throw new Error('No hay afiliado seleccionado.');
            }

            const relaciones = await this.userEntreUserService.findGrupoFamiliar(afiliadoSeleccionado._id);
            const grupoFamiliar = [];

            for (const relacion of relaciones) {
                const adicional = relacion.adicional;

                if (adicional) {
                    const sedeId = adicional?.signoSedes?.[0]?.toString() || '';
                    const empresaId = adicional?.signoEmpresas?.[0]?.toString() || '';
                    const planId = adicional?.signoPlan?.toString() || '';

                    const data = await this.getDataAfiliado(sedeId, empresaId, planId);

                    if (data) {
                        adicional.signoSedes = [{ nombre: data.sede }];
                        adicional.signoEmpresas = [{ nombre: data.empresa }];
                        adicional.signoPlan = data.plan;
                    }

                    grupoFamiliar.push(adicional);
                }
            }

            this.dataSource = new MatTableDataSource(grupoFamiliar);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
            this.flagGrupoFamiliar = grupoFamiliar.length > 0;
        } catch (error) {
            console.error('Se ha producido un error al cargar la lista de familiares vinculados al afiliado.', error);
            this.flagGrupoFamiliar = false;
        }
    }

    async loadGrupoFamiliar() {
        await this.loadDataTable();
        return;
    }

    openDialogConfirmData(data: User): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            const dialogRef = this.dialog.open(ModalConfirmarComponent, {
                width: '720px',
                maxWidth: '94vw',
                maxHeight: '90vh',
                disableClose: true,
                panelClass: 'ds-dialog',
                data,
            });

            dialogRef.afterClosed().subscribe((result: boolean) => {
                resolve(result);
            });
        });
    }

    mostrarDatosGecros() {
        this.mostrarCard = !this.mostrarCard;
    }

    private filtrarSolicitudesValidas(solicitudes: Solicitud[]): Solicitud[] {
        return solicitudes.filter((solicitud: any) => {
            const numberState =
                solicitud?.lastState_numberState ??
                solicitud?.lastState?.numberState ??
                -1;

            return this.debeIncluirSolicitud(solicitud, numberState);
        });
    }

    private debeIncluirSolicitud(solicitud: any, numberState: number): boolean {
        const createdAt = solicitud?.createdAt
            ? new Date(solicitud.createdAt)
            : null;

        if (createdAt && createdAt >= this.FECHA_CORTE_FILTRO) {
            return numberState !== 0;
        }

        return numberState !== 0 && numberState !== 1;
    }

    private async loadSolicitudes(): Promise<void> {
        this.loadingSolicitud = true;

        try {
            const idUser = this.personasService.getPersonaSeleccionada()._id;
            const solicitudes = await this.solicitudesService.getSolicitudesByUser(idUser);

            const solicitudesFiltradas = this.filtrarSolicitudesValidas(solicitudes);

            const solicitudesOrdenadas = solicitudesFiltradas.sort((a, b) => {
                const fechaA = new Date(a.createdAt).getTime();
                const fechaB = new Date(b.createdAt).getTime();
                return fechaB - fechaA;
            });

            this.solicitudesDataSource.data = solicitudesOrdenadas;
            this.solicitudesDataSource.paginator = this.soliPaginator;
        } catch (err) {
            console.error('Error al cargar solicitudes:', err);
        } finally {
            this.loadingSolicitud = false;
        }
    }

    async verSolicitud(solicitud: Solicitud) {
        this.loading = true;
        try {
            const sol = await this.solicitudesService.getSolicitudById(solicitud._id);
            this.solicitudesService.setSolicitudSeleccionada(sol);
            await this.updateSolicitudLeido(sol);
            solicitud.leido = true;
            this.openDialogModaSolicitud();
        } catch (error) {
            console.error('Error al ver la solicitud:', error);
        } finally {
            this.loading = false;
        }
    }

    async updateSolicitudLeido(sol: Solicitud) {
        const solicitud: any = {
            _id: sol._id,
            leido: true,
            titular: sol.titular,
            usuario: sol.usuario,
            pais: sol.pais._id,
            actividad: sol.actividad._id,
        };

        await this.solicitudesService.updateSolicitudLeido(sol._id, solicitud);
    }

    openDialogModaSolicitud(): void {
        const dialogRef = this.dialog.open(OfertasSolicitudComponent, {
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            panelClass: ['full-screen-dialog', 'ds-dialog'],
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe();
    }

    async eliminarFamiliar(adicionalId: string) {
        const confirmacion = await this.guiMsjService.mostrarConfirmacion(
            '¿Está seguro de que desea eliminar este familiar?'
        );
        if (confirmacion) {
            try {
                const afiliadoSeleccionado = this.personasService.getPersonaSeleccionada();
                const relaciones = await this.userEntreUserService.findGrupoFamiliar(
                    afiliadoSeleccionado._id
                );

                const relacionAEliminar = relaciones.find(
                    (rel) => rel.adicional && rel.adicional._id === adicionalId
                );

                if (!relacionAEliminar) {
                    console.error('No se encontró la relación para el adicional:', adicionalId);
                    return;
                }

                await this.userEntreUserService.delete(relacionAEliminar._id);
                this.loadGrupoFamiliar();
            } catch (error) {
                console.error('Error al eliminar familiar:', error);
            }
        }
    }

    cambiarTab(tab: string) {
        this.tabActiva = tab;
    }

    updateValuesReinscripcion(isChecked: boolean) {
        this.formAfiliado.get('reinscripcionOs').setValue(isChecked === true);
    }

    getDomicilioFamiliar(element: any): string {
        const domicilio =
            element &&
            element.signoGecrosAfiliado &&
            element.signoGecrosAfiliado.domicilios
                ? element.signoGecrosAfiliado.domicilios[0]
                : null;

        if (!domicilio) {
            return '—';
        }

        return this.formatDomicilio(domicilio.calle, String(domicilio.numero));
    }

    getNombreSede(element: any): string {
        return element && element.signoSedes && element.signoSedes.length
            ? element.signoSedes[0].nombre
            : '—';
    }

    getNombreEmpresa(element: any): string {
        return element && element.signoEmpresas && element.signoEmpresas.length
            ? element.signoEmpresas[0].nombre
            : '—';
    }

    get gecrosResumen(): { label: string; value: any }[] {
        const gecros = this.usuario && this.usuario.signoGecrosAfiliado;
        if (!gecros) {
            return [];
        }

        return [
            { label: 'Nombre afiliado', value: gecros.nombreAfiliado },
            { label: 'CUIL', value: gecros.cuil },
            { label: 'Número de afiliado', value: gecros.numeroAfiliado },
            { label: 'Documento', value: gecros.documento },
            { label: 'Sexo', value: gecros.sexo },
            { label: 'Estado', value: gecros.estado },
            { label: 'Convenio', value: gecros.convenio },
            { label: 'Plan', value: gecros.plan },
            { label: 'Fecha de nacimiento', value: gecros.fechaNacimiento },
            { label: 'Legajo', value: gecros.legajo },
            { label: 'Email', value: gecros.email },
            { label: 'Agente cuenta', value: gecros.agenteCuenta },
            { label: 'Parentesco', value: gecros.parentesco },
            { label: 'Médico de cabecera', value: gecros.medicoCabecera },
            { label: 'Coberturas', value: gecros.coberturas },
            { label: 'Observaciones', value: gecros.observaciones },
        ];
    }

    async obtenerDatosGecros() {
        if (!this.usuario?.identificacion) {
            console.warn('No hay identificación para consultar Gecros');
            return;
        }

        this.isLoading = true;
        try {
            this.gecrosData = await this.gecrosAfiliadosService.getAfiliadoByIdentificacion(
                this.usuario.identificacion
            );
        } catch (error) {
            console.error('Error al obtener datos de Gecros:', error);
        } finally {
            this.isLoading = false;
        }
    }

    async sincronizarInstitucionalesGecros() {
        const arrayAfiliados = this.gecrosData?.data;
        if (!arrayAfiliados || !Array.isArray(arrayAfiliados) || arrayAfiliados.length === 0) {
            console.warn('No hay datos Gecros válidos para sincronizar');
            return;
        }

        const datosGecros = arrayAfiliados[0];
        this.isLoading = true;

        try {
            const numeroAfiliado = datosGecros.numeroAfiliado;
            if (!numeroAfiliado || numeroAfiliado.length < 3) {
                console.warn('Número de afiliado inválido');
                return;
            }

            const codigoSede = numeroAfiliado.substring(0, 3);
            const sedeGecros = await this.signoSedeService.getSedeByCodigo(codigoSede);
            if (!sedeGecros) {
                console.warn(`No se encontró sede con código ${codigoSede}`);
                return;
            }

            const denominacionPlan = datosGecros.plan;
            const planGecros = buscarPlanPorGecros(denominacionPlan, this.planes) as SignoPlan;
            if (!planGecros) {
                console.warn(`No se encontró plan con denominación "${denominacionPlan}"`);
                return;
            }

            this.formAfiliado.patchValue({
                signoSedes: sedeGecros._id,
                signoPlan: planGecros._id
            });

            this.selectedSede = sedeGecros;
            this.selectedPlan = planGecros;

            // Mantener la DB del afiliado en sync con GECROS (plan + cobertura).
            this.gecrosSyncService
                .sincronizarAfiliado(this.usuario?._id, datosGecros, this.usuario)
                .catch((error) =>
                    console.error('Error al sincronizar GECROS desde administración:', error)
                );

            this.cdr.detectChanges();
            console.log('Sincronización Gecros exitosa');
        } catch (error) {
            console.error('Error al sincronizar datos institucionales:', error);
        } finally {
            this.isLoading = false;
        }
    }

    abrirModalNuevoFamiliar(): void {
        const dialogRef = this.dialog.open(FamiliarModalAltaComponent, {
            minWidth: '60vw',
            minHeight: '80vh',
            disableClose: true,
            data: { titular: this.usuario }
        });

        dialogRef.afterClosed().subscribe(async (result) => {
            if (result && result.success) {
                try {
                    // Crear relación UserEntreUser
                    const parentescoString = this.mapearParentesco(result.parentesco);
                    const relacion: any = {
                        titular: this.usuario,
                        adicional: result.familiar, 
                        parentesco: parentescoString
                    };
                    await this.userEntreUserService.createUserEntreUserAltaFamiliarNueva(relacion, false);

                    // Refrescar tabla
                    await this.loadGrupoFamiliar();
                    this.guiMsjService.msjFormSubmit('Familiar vinculado exitosamente');
                } catch (error) {
                    console.error('Error al crear relación:', error);
                    this.guiMsjService.msjFormSubmit('Error al vincular familiar');
                }
            }
        });
    }

    private mapearParentesco(parentesco: Parentesco): string {
        switch (parentesco) {
            case Parentesco.Esposo: return 'Esposo/a';
            case Parentesco.Concubino: return 'concubino/a';
            case Parentesco.Hijo: return 'HIJO/A';
            default: return '';
        }
    }
}